module.exports = __webpack_public_path__ + "static/media/HE.c4441651.svg";